export default __webpack_public_path__ + "static/media/lush3.ca128b09.webp";